import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
import { ShieldCheck, CreditCard, CheckCircle2, Wallet } from 'lucide-react';
import { useScreenInit } from '../useScreenInit';
export function FinancingPage() {
  useScreenInit();
  return <div className="min-h-screen bg-white" data-id="element-631">
      <Header data-id="element-632" />

      <main className="pt-40 pb-24" data-id="element-633">
        <div className="max-w-4xl mx-auto px-4" data-id="element-634">
          {/* Hero */}
          <div className="text-center mb-16" data-id="element-635">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-[#cef4d2]/50 rounded-full mb-6" data-id="element-636">
              <Wallet className="text-[#54c595]" size={40} data-id="element-637" />
            </div>
            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} className="text-4xl md:text-6xl font-bold text-[#225274] mb-6" data-id="element-638">
              Financings & Insurance
            </motion.h1>
            <p className="text-xl text-[#4F709C] leading-relaxed" data-id="element-639">
              We believe everyone deserves a healthy smile. We offer flexible
              payment options to ensure financial barriers never stand in the
              way of your care.
            </p>
          </div>

          <div className="space-y-12" data-id="element-640">
            {/* Insurance Section */}
            <section className="bg-slate-50 p-8 md:p-12 rounded-[12px] border border-slate-100" data-id="element-641">
              <div className="flex items-center gap-3 mb-6" data-id="element-642">
                <ShieldCheck className="text-[#54c595]" size={32} data-id="element-643" />
                <h2 className="text-3xl font-bold text-[#225274]" data-id="element-644">
                  Accepted Insurance Providers
                </h2>
              </div>
              <p className="text-slate-600 leading-relaxed mb-6" data-id="element-645">
                We accept most dental insurances! If you are unsure of your
                coverage, we can help you understand your benefits and expected
                costs. When dental care is needed, we will walk you through all
                costs involved before scheduling treatment. We will also work
                with your dental insurance company to get the most out of your
                benefits.
              </p>
              <p className="text-[#225274] font-bold" data-id="element-646">
                If you have any insurance questions, let us know!
              </p>
            </section>

            {/* Payment Options Section */}
            <section className="bg-white p-8 md:p-12 rounded-[12px] border-2 border-[#225274] shadow-xl" data-id="element-647">
              <div className="flex items-center gap-3 mb-8" data-id="element-648">
                <CreditCard className="text-[#54c595]" size={32} data-id="element-649" />
                <h2 className="text-3xl font-bold text-[#225274]" data-id="element-650">
                  Payment Options for Patients
                </h2>
              </div>

              <ul className="space-y-4 mb-10" data-id="element-651">
                {['Cash or check', 'Visa / MasterCard / AMEX / Debit card / Flex spending plan debit cards', 'We are pleased to offer pre-payment discounts to our patients who pay before the time of service.'].map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-652">
                    <CheckCircle2 className="text-[#54c595] flex-shrink-0 mt-1" size={20} data-id="element-653" />
                    <span className="text-slate-700 font-medium" data-id="element-654">{item}</span>
                  </li>)}
              </ul>

              <div className="bg-[#cef4d2]/30 p-6 rounded-lg border border-[#54c595]/20" data-id="element-655">
                <h3 className="font-bold text-[#225274] mb-3 text-lg" data-id="element-656">
                  Third-Party Financing
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed mb-6" data-id="element-657">
                  We are also pleased to offer Care Credit dental care
                  financing. Care Credit has been providing no-interest and
                  low-interest loan options for over 25 years to help us make
                  the care patients need comfortable for them and their
                  pocketbooks. We also partner with Sunbit for flexible
                  pay-over-time options.
                </p>
                <div className="flex flex-wrap gap-12 items-center" data-id="element-658">
                  <img src="https://cdn.magicpatterns.com/uploads/mW2EyVLe9HC8vkdhnhCTxs/pasted-image.webp" alt="CareCredit Logo" className="h-12 w-auto object-contain" data-id="element-659" />
                  <img src="https://cdn.magicpatterns.com/uploads/2rr4YFCrgPkDZ7WPUgBkYY/pasted-image.png" alt="Sunbit Logo" className="h-10 w-auto object-contain" data-id="element-660" />
                </div>
              </div>
            </section>
          </div>

          {/* Final Conversion CTA */}
          <div className="mt-20 bg-[#225274] rounded-[12px] p-10 md:p-16 text-center text-white shadow-2xl relative overflow-hidden" data-id="element-661">
            <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -mr-32 -mt-32" data-id="element-662" />
            <div className="relative z-10" data-id="element-663">
              <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-664">
                Ready to Get Started?
              </h2>
              <p className="text-white/80 text-lg mb-10 max-w-2xl mx-auto" data-id="element-665">
                Don't let finances delay your dental care. Apply for flexible
                financing today or schedule a consultation to discuss your
                options with our team.
              </p>
              <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-666">
                <button className="bg-gradient-to-r from-[#225274] via-[#4bafbc] to-[#54c595] hover:brightness-110 text-white px-10 py-4 rounded-full font-bold transition-all shadow-lg shadow-teal-900/20 uppercase tracking-widest" data-id="element-667">
                  APPLY FOR FINANCINGS
                </button>
                <button className="border-2 border-white/30 hover:border-white text-white px-10 py-4 rounded-full font-bold transition-all uppercase tracking-widest" data-id="element-668">
                  BOOK A CONSULTATION
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-669" />
    </div>;
}